// mui(material ui) theme settings
export const themeSettings = {
  palette: {
    primary: {
      darkNavy: "#020c1b",
      navy: "#0a192f",
      lightNavy: "#112240",
      lightestNavy: "#233554",
      navyShadow: "rgba(2,12,27,0.7)",
      slate: "#8892b0",
      lightSlate: "#a8b2d1",
      lightestSlate: "#ccd6f6",
      white: "#e6f1ff",
      green: "#64FFDB",
      greenTint: "rgba(100,255,218,0.1)",
    },
  },
  typography: {
    fontFamily: ["Rubik", "sans-serif"].join(","),
    fontSize: 12,
    h1: {
      fontFamily: ["Rubik", "sans-serif"].join(","),
      fontSize: 37,
    },
    h2: {
      fontFamily: ["Rubik", "sans-serif"].join(","),
      fontSize: 28,
    },
    h3: {
      fontFamily: ["Rubik", "sans-serif"].join(","),
      fontSize: 23,
    },
    h4: {
      fontFamily: ["Rubik", "sans-serif"].join(","),
      fontSize: 20,
    },
    h5: {
      fontFamily: ["Rubik", "sans-serif"].join(","),
      fontSize: 16,
    },
    h6: {
      fontFamily: ["Rubik", "sans-serif"].join(","),
      fontSize: 14,
    },
  },
};
